// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__KwEBQ","row":"Option_row__2azdS"};